import { render } from "./TopBar.vue?vue&type=template&id=27058c76&scoped=true"
import script from "./TopBar.vue?vue&type=script&lang=js"
export * from "./TopBar.vue?vue&type=script&lang=js"

import "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=27058c76&scoped=true&lang=css&external"
import "./TopBar.vue?vue&type=style&index=1&id=27058c76&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27058c76"]])

export default __exports__